export const container = {
  display: 'inline-block',
  position: 'relative',
}

export const input = {
  height: '100%',
  left: 0,
  opacity: 0,
  position: 'absolute',
  top: 0,
  width: '100%',
  zIndex: 1,
}
